<template>
  <path
    d="M3 8C3 7.72386 3.22386 7.5 3.5 7.5L12.5 7.5C12.7761 7.5 13 7.72386 13 8C13 8.27614 12.7761 8.5 12.5 8.5H3.5C3.22386 8.5 3 8.27614 3 8Z"
    fill="currentColor" />
</template>
